import React, { ChangeEvent } from 'react';

import { MinusIcon, PlusIcon } from 'assets/icons';
import { Field } from 'common/components/form/Input';
import { decreaseValue, getNumber, increaseValue } from 'common/components/form/Number/helpers';
import { useFormikField } from 'common/components/form/useFormikField';
import { FieldWrapper, IFormInput } from 'common/components/form/Wrapper';
import { InputIcon } from 'common/components/form/Wrapper/Wrapper.styled';

import { Counter } from './Number.styled';

type ICounterField = Omit<IFormInput, 'type' | 'icon'>;

export const CounterField = ({ name, label, step = 1, disabled, ...rest }: ICounterField) => {
  const { value, error, hasError, setValue } = useFormikField(name);

  return (
    <FieldWrapper
      name={name}
      label={label}
      isRequired={rest.required}
      isDisabled={disabled}
      error={hasError ? `${error}` : undefined}
      flexDirection={rest.flexDirection}
      fontSize={rest.fontSizeLabel}
      paddingLabel={rest.paddingLabel}
      margin={rest.margin}
    >
      {rest.contentLeftSide && rest.contentLeftSide}
      <Counter
        $hasError={hasError}
        $isDisabled={disabled}
        $minNumber={value}
        error={rest.customError}
        $border={rest.border}
        $disableFocusWithin={rest.disableFocusWithin}
        $width={rest.width}
        $inputIconRounded={rest.inputIconRounded}
      >
        <InputIcon
          $hasError={hasError}
          $isDisabled={disabled}
          $inputIconRounded={rest.inputIconRounded}
          onClick={() => {
            if (!disabled) {
              setValue(decreaseValue(value, step, rest.min));
            }

            if (typeof rest.clearCustomError === 'function') {
              rest.clearCustomError();
            }
          }}
        >
          <MinusIcon />
        </InputIcon>
        <Field
          {...rest}
          type="number"
          name={name}
          disabled={disabled}
          step={step}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            setValue(getNumber(event.target.value, rest.min, rest.max))
          }
        />
        <InputIcon
          $hasError={hasError}
          $isDisabled={disabled}
          $inputIconRounded={rest.inputIconRounded}
          onClick={() => {
            if (!disabled) {
              setValue(increaseValue(value, step, rest.max));
            }

            if (typeof rest.clearCustomError === 'function') {
              rest.clearCustomError();
            }
          }}
        >
          <PlusIcon />
        </InputIcon>
      </Counter>
    </FieldWrapper>
  );
};
